import React from 'react';
import Slider, { Handle } from 'rc-slider';

import { Ball, SliderContainer } from './style';

const markStyle = {
    fontWeight: 'bold',
    fontSize: 14,
    top: -2,
    transform: 'translateX(-100%)',
};

const handleStyle = {
    height: 24,
    width: 24,
    marginTop: -8,
    marginLeft: 5,
    backgroundColor: '#F9F9F9',
    border: '2px solid #B5B5B5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const handle = (props) => {
    return (
        <Handle {...props}>
            <Ball isActive={props.isActive}/>
        </Handle>
    );
};

const SliderRow = ({ min, max, isActive, value, step, changeValue }) => {
    return (
        <SliderContainer>
            <Slider
                min={min}
                max={max}
                step={step || 1}
                marks={{
                    [min]: {
                        style: { ...markStyle, transform: '' },
                        label: min
                    },
                    [max]: {
                        style: markStyle,
                        label: max
                    }
                }}
                handleStyle={handleStyle}
                railStyle={{
                    height: 8,
                }}
                trackStyle={{
                    backgroundColor: isActive ? '#d73e67' : '#09CEFD',
                    height: 8
                }}
                dotStyle={{ display: 'none' }}
                dots={false}
                handle={(props) => handle({ ...props, isActive })}
                value={value}
                onChange={(value) => changeValue(value)}
            />
        </SliderContainer>
    );
};

export default SliderRow;
